module.exports = __webpack_public_path__ + "img/pajamas.f610e8c9.svg";